import { usePage } from "@inertiajs/react";
import InvitationFormPage, { DefaultInvitationLayout, defaultInvitationBackHref } from "@/pages/invitations/invitation-form-page";
import { invitations_path, manage_organizations_path, users_path } from "@/routes";

function NewInvitation({ invitation = {} }) {
  const { current_tenant: currentTenant } = usePage().props;
  const backHref = defaultInvitationBackHref({ currentTenant });

  return (
    <InvitationFormPage
      invitation={invitation}
      title="Invitér"
      eyebrow="Invitation"
      description={`Angiv e-mail og rolle. Invitationen bliver oprettet i ${currentTenant?.name || "den aktive organisation"}.`}
      backHref={backHref}
      submitPath={invitations_path()}
      breadcrumbs={[
        currentTenant?.id
          ? { label: "Brugere", href: users_path() }
          : { label: "Organisationer", href: manage_organizations_path() },
        { label: "Invitér" }
      ]}
      organizationLocked={true}
    />
  );
}

NewInvitation.layout = (page) => {
  const { current_tenant: currentTenant } = page.props;
  const backHref = defaultInvitationBackHref({ currentTenant });

  return (
    <DefaultInvitationLayout
      page={page}
      title="Invitér"
      backHref={backHref}
      breadcrumbs={[
        currentTenant?.id
          ? { label: "Brugere", href: users_path() }
          : { label: "Organisationer", href: manage_organizations_path() },
        { label: "Invitér" }
      ]}
    />
  );
};

export default NewInvitation;
